import { render, staticRenderFns } from "./sweet.vue?vue&type=template&id=3dd5dcf3&scoped=true"
import script from "./sweet.vue?vue&type=script&lang=js"
export * from "./sweet.vue?vue&type=script&lang=js"
import style0 from "./sweet.vue?vue&type=style&index=0&id=3dd5dcf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd5dcf3",
  null
  
)

export default component.exports